// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiSpecialtyPharmacy {
    'name'?: string;
    'npi'?: string;
    'preferred'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiSpecialtyPharmacy>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "preferred",
            "baseName": "preferred",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiSpecialtyPharmacy.attributeTypeMap;
    }
}
